import {
  Accordion,
  AccordionItem,
} from '@twistopayments/design-system/components/atoms/accordion'
import { Link } from '@twistopayments/design-system/components/atoms/link'

import type { SectionsFaqComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './faq.styles'

export const Faq = ({
  headline,
  highlighted,
  description,
  column,
  answers,
}: SectionsFaqComponent) => {
  const { before, after, highlight } = useHighlightedText(
    headline || '',
    highlighted
  )

  return (
    <section className="faq-container" css={styles.faq}>
      <div css={styles.inner}>
        {headline && (
          <h2 css={styles.headline}>
            {before}
            <span css={styles.highlighted}>{highlight}</span>
            {after}
          </h2>
        )}
        {description && <p css={styles.description}>{description}</p>}
        {answers && (
          <Accordion
            allowMultipleExpanded
            css={[styles.answers, column && styles[column]]}
          >
            {answers.map((answer) => (
              <AccordionItem key={answer.id} noDivider css={styles.answerItem}>
                {{
                  heading: answer.headline || '',
                  panel: answer.links?.length
                    ? insertLinks({
                        fullText: answer.text,
                        links: answer.links,
                      })
                    : answer.text || '',
                }}
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </div>
    </section>
  )
}

function insertLinks({
  fullText,
  links = [],
}: {
  fullText?: string
  links?: Array<{ text?: string; url?: string }>
}): JSX.Element {
  if (!fullText || links.length === 0) {
    return <>{fullText}</>
  }

  const [link, ...rest] = links

  if (!link.text || !link.url) {
    return insertLinks({ fullText, links: rest })
  }

  const startIndex = fullText.indexOf(link.text)

  if (startIndex === -1) {
    return insertLinks({ fullText, links: rest })
  }

  const endIndex = startIndex + link.text.length
  const before = fullText.slice(0, startIndex)
  const after = fullText.slice(endIndex)

  return (
    <>
      {insertLinks({ fullText: before, links: rest })}
      <Link to={link.url}>{link.text}</Link>
      {insertLinks({ fullText: after, links: rest })}
    </>
  )
}
